import React from 'react';
import { useSelector } from 'react-redux';
import {
  FieldText,
  Button
} from '@npm-registry/eapteka-ui';
import { text } from '../../../../text';
import { Spinner } from '../../../core/Spinner/Spinner';
import { usePromocode } from '../hooks/usePromocode';
import { selectLoading } from '../../../../store/promocode';
import styles from './PromocodeForm.scss';

export const PromocodeForm = () => {
  const loading = useSelector(selectLoading);

  const {
    promocode,
    disabled,
    hasError,
    onChange,
    onSubmit
  } = usePromocode();

  return (
    <form onSubmit={onSubmit}>
      <FieldText
        value={promocode}
        onChange={onChange}
        className={styles.field}
        label={text['promocode.placeholder']}
        errorMessage={
          hasError ? text['promocode.invalid'] : ''
        }
        hasError={hasError}
        hasClear={!!promocode}
        componentSize="m"
      />
      <Button
        type="submit"
        disabled={disabled}
        className={styles.button}
      >
        {loading === 'pending' ? (
          <Spinner />
        ) : (
          text['promocode.apply']
        )}
      </Button>
    </form>
  );
};
